import React from "react";
import { Col, Row, Typography, Breadcrumb } from "antd";
import ProtocolsTable from "../../../components/Tables/ProtocolsTable";
import { Link } from "react-router-dom";
import { translate } from "../../../locale";

const { Title } = Typography;

const Protocols = () => {
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="12">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Protocolo")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Protocolos")}
          </Title>
        </Col>

        <Col span="24" className="mt-6">
          <ProtocolsTable />
        </Col>
      </Row>
    </div>
  );
};

export default Protocols;
